import { Component } from "@angular/core";
import { FieldType } from "@ngx-formly/core";

@Component({
  selector: "formly-field-tab",
  template: `
    <formly-tabs-tab [title]="title" [disabled]="disabled" [hidden]="hidden">
      <formly-field
        *ngFor="let f of field.fieldGroup"
        [field]="f"
      ></formly-field>
    </formly-tabs-tab>
  `,
  host: {
    "[class]": 'field.fieldGroupClassName || ""',
  },
  standalone: false,
})
export class FormlyFieldTabComponent extends FieldType {
  get title(): string {
    return this.props["tabTitle"];
  }

  get disabled(): boolean {
    return this.props["tabDisabled"];
  }

  set disabled(value: boolean) {
    this.props["tabDisabled"] = !!value;
  }

  get hidden(): boolean {
    return this.props["tabHidden"];
  }

  set hidden(value: boolean) {
    this.props["tabHidden"] = !!value;
  }
}
